<ng-container *ngIf="loading">
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>

<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
  <!--mat-card-header>
    <mat-card-title>Grupo Firma</mat-card-title>
  </mat-card-header-->
  <mat-card-content>

    <!-- quitar los mat-card-content estan repetidos -->
    <form class="form-container" (ngSubmit)="onSubmit(signatureGroupForm)" #signatureGroupForm="ngForm" >
      <mat-card class="general-wf-card" appearance="outlined">
        <mat-card-header>
          <mat-card-title>Datos Generales</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div id="container" class="formControl">
            <div class="control">
              <mat-form-field class="controlWidth">
                <mat-label>Nombre Grupo</mat-label>
                  <input matInput type="text" name="signatureGroup.description" [(ngModel)]="signatureGroup.description">
                  <mat-error>{{ violations['signatureGroup.description'] }}</mat-error>
              </mat-form-field>
            </div>
            
            <div class="control">
              <mat-slide-toggle [(ngModel)]="signatureGroup.active" name="signatureGroup.active"> {{ signatureGroup.active? 'Activo':'Inactivo'}} </mat-slide-toggle>
            </div>
          </div>
        </mat-card-content>
        <mat-card-footer class="general-wf-card-footer">
        </mat-card-footer>
      </mat-card>
      <br>
      
      <mat-card class="general-wf-card" appearance="outlined">
        <mat-card-header>
          <mat-card-title>Firmas</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          
          <div class="control"> 
            <button mat-flat-button class="button buttonWidth" type="button" (click)="addSignature()">
              Agregar Firma
            </button>
          </div>

          <div *ngFor="let signatureConfiguration of signatureGroup.signatureConfigurations; let listIndex = index">
            
            <div id="container" class="formControl">
                                
              <!--div class="control">
                  <mat-form-field class="controlWidth">
                    <mat-label>Beneficio</mat-label>
                    <mat-select [(ngModel)]="signatureConfiguration.number"  [compareWith]="compareBenefit" name="benefitConfiguration.benefit.description{{listIndex}}">
                      @for (benefit of benefits ; track benefit.id) {
                        <mat-option [value]="benefit">{{ benefit.description }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
              </div-->

              <div class="control">
                  <mat-form-field class="imput-full-width">
                  <mat-label>Numero</mat-label>
                  <input type="number" matInput name="signatureConfiguration.number{{listIndex}}" [(ngModel)]="signatureConfiguration.number" [readonly]="true">
                  </mat-form-field>
              </div>

              <div class="control">
                <mat-form-field class="imput-full-width">
                  <mat-label>Descripción</mat-label>
                  <input type="text" matInput name="signatureGroup.signatureConfigurations{{listIndex}}.description" [(ngModel)]="signatureConfiguration.description" #descModel="ngModel">
                  <mat-error>{{ violations['signatureGroup.signatureConfigurations{{listIndex}}.description'] }}</mat-error>
                </mat-form-field>
              </div>

              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Tipo firma</mat-label>
                  <mat-select [(ngModel)]="signatureConfiguration.signatureType" [compareWith]="compareSignatureTypes" name="signatureGroup.signatureConfigurations{{listIndex}}.signatureType">
                    @for (signatureType of signatureTypes ; track signatureType.id) {
                      <mat-option [value]="signatureType">{{ signatureType.description }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="control" [hidden]="signatureConfiguration.signatureType!.code != 'FIJO'">
                <mat-form-field class="controlWidth">
                  <mat-label>Usuario fijo</mat-label>
                  <mat-select [(ngModel)]="signatureConfiguration.signatureUser" [compareWith]="compareUsersWithRolAut" name="signatureGroup.signatureConfigurations{{listIndex}}.signatureUser">
                    @for (userWithRolAut of usersWithRolAut ; track userWithRolAut.id) {
                      <mat-option [value]="userWithRolAut">{{ userWithRolAut.person.name }} {{ userWithRolAut.person.paternalSurname }} {{ userWithRolAut.person.maternalSurname }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

            </div>
          </div>

        </mat-card-content>
        <mat-card-footer class="general-wf-card-footer">
        </mat-card-footer>
      </mat-card>

      <br>
      <div class="formControl">
        <div class="control">
          <button mat-flat-button class="button buttonWidth">
            {{(signatureGroup.id > 0)? 'Modificar': 'Crear'}}
          </button>
        </div>
      </div>
      <br>
    </form>
    
</mat-card-content>
<mat-card-footer class="general-wf-card-footer">
</mat-card-footer>
</mat-card>